// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"IEPiNW","accordionIcon":"_3uW8hU"};